<template>
  <div>
    <ui-form @submit.prevent.stop="save_form" :errors="errors" store="event">
      <div>
        <div class="bg-white space-y-6">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">Общая информация</h3>
            <p class="mt-1 text-sm text-gray-500">
              Укажите название мероприятия, даты проведения и прочую информацию. Мероприятие не будет отображаться на
              сайте до тех пор, кока вы не активируете его на странице мероприятий.
            </p>
          </div>

          <div class="grid grid-cols-3 gap-6">
            <ui-form-item name="name" class="col-span-3" label="Название" required>
              <ui-form-text
                  placeholder="Пример: Международный интеллектуальный турнир «Нескучные задачки и головоломки»"/>
            </ui-form-item>

            <ui-form-item name="theme" class="col-span-3" label="Предметная область" required>
              <ui-form-text placeholder="Пример: математика, задания на логику"/>
            </ui-form-item>

            <ui-form-item name="age" class="col-span-2" label="Возраст"
                          text-help="Возрастная категория участников. Например: дошкольники 5-7 лет,
                          учащиеся 1 класса и т.п."
                          required>
              <ui-form-text placeholder="Пример: дошкольники 5-7 лет"/>
            </ui-form-item>

            <ui-form-item name="cost" class="col-span-1" required label="Стоимость участия">
              <ui-form-number type="number" label="Цена участия" required
                              placeholder="Сумма взноса за участие"/>
            </ui-form-item>
          </div>

          <div class="grid grid-cols-6 gap-6">

            <ui-form-item name="started_reg_at" class="col-span-6 sm:col-span-6 lg:col-span-2" label="Регистрация"
                          text-help="Дата начала регистрации" required>
              <ui-form-date :model-value="started_reg_at" @update:modelValue="val => {input('started_reg_at', val)}"/>
            </ui-form-item>
            <ui-form-item name="started_at" class="col-span-6 sm:col-span-6 lg:col-span-2" label="Старт"
                          text-help="Дата начала мероприятия" required>
              <ui-form-date :model-value="started_at" @update:modelValue="val => {input('started_at', val)}"/>
            </ui-form-item>
            <ui-form-item name="ended_at" class="col-span-6 sm:col-span-6 lg:col-span-2" label="Окончание"
                          text-help="Дата завершения мероприятия" required>
              <ui-form-date :model-value="ended_at" @update:modelValue="val => {input('ended_at', val)}"/>
            </ui-form-item>
          </div>


          <div class="grid grid-cols-3 gap-6">
            <ui-form-item name="description" class="col-span-3" label="Анотация мероприятия" required
                          text-help='Анонс мероприятия, для отображения на сайте'>
              <ui-form-editor :model-value="description" @update:modelValue="val => {input('description', val)}"
                              :tools="[
                  'paragraph', 'header', 'list', 'marker', 'delimiter', {name: 'attaches', config: { endpoint: `events/${id}/attaches`, additionalRequestHeaders: {
              'Authorization' : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjEsImV4cCI6MTY1OTQ0MzU0N30=.KuXWSn/YeZL4uXDjO6qYOS56GkIbPCsMoDvVG7PQYcU='
                  }}},'warning', 'table'
              ]"/>
            </ui-form-item>
          </div>

          <div class="py-3 text-right">
            <ui-button type="submit" v-show="isModify">Сохранить</ui-button>
          </div>
        </div>

      </div>
    </ui-form>

  </div>
</template>

<script>
import UiButton from "@/components/ui/button/UiButton";
import UiFormDate from "@/components/ui/form/date/UiFormDate";
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormText from "@/components/ui/form/UiFormText";
import UiForm from "@/components/ui/form/UiForm";
import {mapActions, mapGetters} from "vuex";
import UiFormEditor from "@/components/ui/form/editor/UiFormEditor";
import UiFormNumber from "@/components/ui/form/UiFormNumber";

export default {
  name: "EventEditIndex",
  components: {UiFormNumber, UiFormDate, UiFormEditor, UiForm, UiFormText, UiFormItem, UiButton},
  data() {
    return {}
  },
  props: ['id'],
  methods: {
    test(v) {
      console.log(v)
    },
    ...mapActions('event', ['save']),
    input(field, value) {
      this.$store.commit('event/setField', {field, value})
    },
    async save_form() {
      const event = await this.save();
      console.log(event)

      /* if (event.id) {
         await this.$store.dispatch('event/questions/add')
         await this.$router.push({name: 'EventEditPay', params: {id: event.id}})
       }*/

    }
  },
  computed: {
    ...mapGetters('event', ['started_reg_at', 'started_at', 'ended_at', 'description', 'errors', 'isModify']),
  },
}
</script>

<style scoped>

</style>